import { Injectable, inject } from '@angular/core';
import { NAVIGATOR } from '../../constances/global-objects';

@Injectable({ providedIn: 'root' })
export class VibrateService {
  private navigator = inject<Navigator>(NAVIGATOR);

  canVibrate = false;

  vibrate(): void {
    if (this.canVibrate) {
      this.navigator.vibrate(200);
    }
  }
}
